<form #orderForm="ngForm" name="orderForm" id="orderForm"
  *ngIf="!this.isSubmitted">
  <nb-card style="height: 100%">
    <nb-card-header>
      <div class="row">
        <div class="col-lg-12 col-12">
          <h2>
            Create
          </h2>
        </div>
      </div>
    </nb-card-header>
    <nb-card-body [nbSpinner]="isLoading">

      <div class="row">
        <div class="col-lg-3 col-12">
          <nb-card>
            <nb-card-header>
              <div class="row">
                <div class="col-lg-12 col-12">
                  <h5>Customer Details</h5>
                </div>
              </div>
              <mat-divider></mat-divider>
            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-lg-12 col-12">
                  <mat-form-field style="width: 100%">
                    <mat-label>Customer</mat-label>
                    <mat-select id="customer" required
                      [(ngModel)]="cart.customerId" name="customer"
                      #customer="ngModel"
                      (ngModelChange)="onCustomerSelect()">
                      <mat-option>
                        <ngx-mat-select-search [(ngModel)]="this.searchCustomer"
                          (ngModelChange)="filterCustomers()"
                          placeholderLabel="Find customer..."
                          noEntriesFoundLabel="No customer found"
                          name="customerSearch"
                          #customerSearch="ngModel">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngIf="this.customerList.length === 0">
                        Please search for a customer.
                      </mat-option>
                      <mat-option *ngFor="let customer of this.customerList"
                        [value]="customer.id">
                        {{customer.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div [hidden]="customer.valid || customer.pristine" class="alert
                    alert-danger">
                    Customer is required
                  </div>

                  <!-- Company -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Company</mat-label>
                    <input [(ngModel)]="this.cart.shippingAddress.company"
                      matInput type="text" #company="ngModel"
                      id="company" name="company">
                    <button *ngIf="this.cart.shippingAddress.company"
                      matSuffix mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.company= ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- Shipping Address -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Address</mat-label>
                    <input [(ngModel)]="this.cart.shippingAddress.address"
                      matInput type="text" #address="ngModel"
                      id="address" name="address">
                    <button *ngIf="this.cart.shippingAddress.address"
                      matSuffix mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.address= ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- City -->
                  <mat-form-field style="width: 100%">
                    <mat-label>City</mat-label>
                    <input [(ngModel)]="this.cart.shippingAddress.city" matInput
                      type="text" #city="ngModel" id="city"
                      name="city">
                    <button  *ngIf="this.cart.shippingAddress.city"
                      matSuffix mat-icon-button
                      aria-label="Clear" (click)="this.cart.shippingAddress.city=
                      ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- state -->
                  <mat-form-field>
                    <mat-label>State</mat-label>
                    <mat-select id="state"
                      [(ngModel)]="this.cart.shippingAddress.state" name="state"
                      #state="ngModel">
                      <mat-option [value]="''">None</mat-option>
                      <mat-option *ngFor="let state of this.states"
                        [value]="state.abbreviation">
                        {{state.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- Zip -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Postal Code</mat-label>
                    <input [(ngModel)]="this.cart.shippingAddress.zip" matInput
                      type="text" #zip="ngModel" id="zip"
                      name="zip">
                    <button *ngIf="this.cart.shippingAddress.zip"
                      matSuffix mat-icon-button
                      aria-label="Clear" (click)="this.cart.shippingAddress.zip=
                      ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- Phone -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Phone #</mat-label>
                    <input [(ngModel)]="this.cart.shippingAddress.phoneNumber"
                      matInput type="text"
                      #phoneNumber="ngModel" id="phoneNumber"
                      name="phoneNumber">
                    <button
                      *ngIf="this.cart.shippingAddress.phoneNumber" matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.phoneNumber= ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- email -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Email</mat-label>
                    <input [(ngModel)]="this.cart.shippingAddress.email"
                      matInput type="text" #email="ngModel"
                      id="email" name="email">
                    <button *ngIf="this.cart.shippingAddress.email"
                      matSuffix mat-icon-button
                      aria-label="Clear"
                      (click)="this.cart.shippingAddress.email= ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- Ordered By -->
                  <!-- <mat-form-field style="width: 100%">
                    <mat-label>Ordered By</mat-label>
                    <input [(ngModel)]="this.cart.orderedBy" matInput
                      type="text" #userMessage="ngModel"
                      id="orderedBy" name="orderedBy">
                    <button mat-button *ngIf="this.cart.orderedBy" matSuffix
                      mat-icon-button aria-label="Clear"
                      (click)="this.cart.orderedBy = ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field> -->

                  <!-- Comments -->
                  <!-- <mat-form-field style="width: 100%">
                    <mat-label>Comments</mat-label>
                    <input [(ngModel)]="this.cart.userMessage" matInput
                      type="text" #userMessage="ngModel"
                      id="userMessage" name="userMessage">
                    <button mat-button *ngIf="this.cart.userMessage" matSuffix
                      mat-icon-button aria-label="Clear"
                      (click)="this.cart.userMessage= ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field> -->

                  <!-- Contract Year-->
                  <mat-form-field style="width: 100%">
                    <mat-label>Contract Year</mat-label>
                    <input [(ngModel)]="this.cart.contractYear" matInput
                      type="text" #contractYear="ngModel"
                      id="contractYear" name="contractYear">
                    <button  *ngIf="this.cart.contractYear" matSuffix
                      mat-icon-button aria-label="Clear"
                      (click)="this.cart.contractYear= ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                  


                  <!-- Contract Template -->
                  <mat-form-field style="width: 100%">
                    <mat-label>Contract Template</mat-label>
                    <mat-select id="contractTemplate" required
                    [(ngModel)]="this.cart.contractTemplate"
                    name="contractTemplate"
                    #contractTemplate="ngModel"
                    (selectionChange)="onTemplateChange($event)"
                    >
                    <mat-option *ngFor="let template of this.contractTemplates"
                      [value]="template">
                      {{template.name}}
                    </mat-option>
                  </mat-select>
                  </mat-form-field>

                  <mat-label>Offer Date</mat-label>
                  <ejs-datepicker format='MM/dd/yyyy'[value]="EffectiveDate" (change)="onEffectiveChange($event)"></ejs-datepicker>

                  <mat-label>Expiration Date</mat-label>
                  <ejs-datepicker format='MM/dd/yyyy'[value]="ExpirationDate" (change)="onExpirationChange($event)"></ejs-datepicker>


                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
        <div class="col-lg-9 col-12">
          <div class="row">
            
            <div class="col-lg-12 col-12">
              <!-- <ejs-calendar [value]="ExpirationDate" (change)="onDateChange($event)"></ejs-calendar> -->
              <nb-card [ngClass]="isPastDue ? 'borderColor' : '' " *ngIf="this.cart.contractTemplate && this.cart.contractTemplate.name != 'MSA' && this.cart.contractTemplate.name != 'Amendment'" >
                <nb-card-header>
                  <div class="row">
                    <div class="col-lg-12 col-12">
                      <h5>Offer Line Items</h5> <br *ngIf="isPastDue">
                        <b><h6 style="color: darkred;" *ngIf="isPastDue">{{this.cart.customer.name}} has a past due balance</h6></b>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </nb-card-header>
                <nb-card-body style="padding-top: 5px;">
                  <div class="col-lg-12 col-12" style="overflow-x: auto;">
                    <button *ngIf="cart.customerId" class="addItemButton" mat-icon-button type="button"
                      (click)="addLine()">
                      <fa-icon style="color: #253d5b" class="me-2" [icon]="faPlus" size="lg"></fa-icon>
                      Add Line Item
                    </button>
                    <table class="table" style="border: 0px; width:
                      100%;">
                      <thead>
                        <tr>
                          <!-- <th>Item #</th> -->
                          <!-- <th>{{"Variety" | tenantWords}}</th> -->
                          <th>Product</th>
                          <th>Description</th>
                          <!-- <th>Crop Year</th> -->
                          <th>Quantity</th>
                          <th>U/M</th>
                          <th>Price/Unit</th>
                          <th>Currency</th>
                          <!-- <th>Pkg. Type</th> -->
                          <th>Total</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody *ngIf="cart.customerId" >
                        <tr *ngFor="let line of this.cart.items; let
                        lineIndex=index" (click)="editLine(lineIndex);">
                       

                        <td style="max-width: 90px;">
                          <div *ngIf="this.selectedLineIndex !== lineIndex">{{line.inventoryItem.name}}</div>
                          <div *ngIf="this.selectedLineIndex === lineIndex">
                            <mat-form-field style="width: 100%;">
                              <mat-label>Product</mat-label>
                              <mat-select id="product"
                                [(ngModel)]="this.cart.items[selectedLineIndex].inventoryItem"
                                name="product" #product="ngModel">
                                <!-- (ngModelChange)="onItemSelect()" -->
                                <mat-option>
                                  <ngx-mat-select-search [(ngModel)]="this.searchItemNumber"
                                    (ngModelChange)="filterProducts()"
                                    placeholderLabel="Find product..."
                                    noEntriesFoundLabel="No product found"
                                    name="productSearch"
                                    #productSearch="ngModel">
                                  </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngIf="this.itemList.length === 0">
                                  Please search for an item.
                                </mat-option>
                                <mat-option *ngFor="let product of
                                  this.itemList" [value]="product">
                                  {{product.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </td>
        
                        <td style="max-width: 150px;">
                          <div *ngIf="this.selectedLineIndex !== lineIndex">{{line.inventoryItem.description}}</div>
                          <div *ngIf="this.selectedLineIndex === lineIndex">
                            <mat-form-field style="width: 100%;">
                              <mat-label>Description</mat-label>
                              <mat-select id="productDescription"
                                [(ngModel)]="this.cart.items[selectedLineIndex].inventoryItem"
                                name="productDescription" #product="ngModel">
                                <mat-option>
                                  <ngx-mat-select-search [(ngModel)]="this.searchItemDesc"
                                    (ngModelChange)="filterProductDesc()"
                                    placeholderLabel="Find product..."
                                    noEntriesFoundLabel="No product found"
                                    name="productDescSearch"
                                    #productDescSearch="ngModel">
                                  </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngIf="this.itemList.length === 0">
                                  Please search for an item.
                                </mat-option>
                                <mat-option *ngFor="let product of
                                  this.itemList" [value]="product">
                                  {{product.description}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </td>
                        <!-- <td style="max-width: 100px;">
                          <div *ngIf="this.selectedLineIndex !== lineIndex">{{line.cropYear}}</div>
                          <div *ngIf="this.selectedLineIndex === lineIndex">
                            <mat-form-field style="width: 90px;">
                              <mat-label>Crop Year</mat-label>
                              <input
                                [(ngModel)]="this.cart.items[selectedLineIndex].cropYear"
                                matInput
                                #cropYear="ngModel" id="cropYear"
                                name="cropYear">
                            </mat-form-field>
                          </div>
                        </td> -->
                        <!-- <td style="max-width: 100px;">
                          <div *ngIf="this.selectedLineIndex !== lineIndex">{{line.contractYear}}</div>
                          <div *ngIf="this.selectedLineIndex === lineIndex">
                            <mat-form-field style="width: 90px;">
                              <mat-label>Contract Year</mat-label>
                              <input
                                [(ngModel)]="this.cart.items[selectedLineIndex].contractYear"
                                matInput
                                #contractYear="ngModel" id="contractYear"
                                name="contractYear">
                            </mat-form-field>
                          </div>
                        </td> -->
                        <td style="max-width: 70px;">
                          <div *ngIf="this.selectedLineIndex !== lineIndex">{{line.quantity}}</div>
                          <div *ngIf="this.selectedLineIndex === lineIndex">
                            <mat-form-field style="width: 100%;">
                              <mat-label>Quantity</mat-label>
                              <input
                                [(ngModel)]="this.cart.items[selectedLineIndex].quantity"
                                matInput required
                                type="number" [min]="isQuote ? null : 0"
                                #lineQuantityInput="ngModel"
                                id="lineQuantityInput"
                                name="lineQuantityInput">
                            </mat-form-field>
                          </div>
                        </td>
                        <td style="max-width: 70px;">
                          <div *ngIf="this.selectedLineIndex !== lineIndex">
                            <h6 class="fw-normal">{{line.unitOfMeasure}}</h6>
                          </div>
                          <div *ngIf="this.selectedLineIndex === lineIndex">
                            <mat-form-field style="width: 100%;">
                              <mat-label>U/M</mat-label>
                              <mat-select id="unitOfMeasure"
                                [(ngModel)]="this.cart.items[selectedLineIndex].unitOfMeasure"
                                name="unitOfMeasure" #unitOfMeasure="ngModel">
                                <mat-option value="lbs">lbs</mat-option>
                                <mat-option value="kg">kg</mat-option>
                                <mat-option value="kga">kga</mat-option>
                                <mat-option value="Each">Each</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          
                        </td>
                        <td style="max-width: 70px;">
                          <div *ngIf="this.selectedLineIndex !== lineIndex">{{line.price | currency}}</div>
                          <div *ngIf="this.selectedLineIndex === lineIndex">
                            <mat-form-field style="width: 100%;">
                              <mat-label>Price/Unit</mat-label>
                              <input
                                [(ngModel)]="this.cart.items[selectedLineIndex].price"
                                matInput type="number"
                                #prices="ngModel" id="prices" name="prices">
                            </mat-form-field>
                          </div>
                        </td>
                        <td style="max-width: 70px;">
                          <div *ngIf="this.selectedLineIndex !== lineIndex">
                            <h6 class="fw-normal">{{line.currency}}</h6>
                          </div>
                          <div *ngIf="this.selectedLineIndex === lineIndex">
                            <mat-form-field style="width: 100%;">
                              <mat-label>Currency</mat-label>
                              <mat-select id="currency"
                                [(ngModel)]="this.cart.items[selectedLineIndex].currency"
                                name="currency" #currency="ngModel">
                                <mat-option *ngFor="let code of
                                  this.currencyList" [value]="code">
                                    {{code}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          
                        </td>
                        <!-- <td style="max-width: 100px;">
                          <div *ngIf="this.selectedLineIndex !== lineIndex">
                            <h6>{{line.packageObj.name}}</h6>
                          </div>
                          <div *ngIf="this.selectedLineIndex === lineIndex">
                            <mat-form-field style="width: 90px;">
                              <mat-label>Package</mat-label>
                              <mat-select id="packageType"
                                [(ngModel)]="this.cart.items[selectedLineIndex].packageObj"
                                (ngModelChange)="setPackage($event, this.cart.items[selectedLineIndex])"
                                name="packageType" #packageType="ngModel"
                                [compareWith]="comparePackages">
                                <mat-option *ngFor="let packageOpt of
                                  this.packages" [value]="packageOpt">
                                    {{packageOpt.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          
                        </td> -->
                        <td>
                          {{line.quantity * line.price | currency}}
                        </td>
                       
                        <td style="max-width: 100px;">
                          <button mat-icon-button
                            (click)="deleteLine(lineIndex,line);"
                            (keydown.Tab)="addLine()">
                            <fa-icon class="trashCan" [icon]="faTrash"></fa-icon>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>
                            <h6><b>Total:</b></h6>
                          </td>
                          <td>
                            <!-- {{getTotalLbs()}} -->
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            {{getTotalPrice() | currency}}
                          </td>
                          <!-- <td></td> -->
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </nb-card-body>
                <!-- <nb-card-footer>
                  <div class="row">
                    <div class="col-lg-12 col-12" style="text-align: right;">
                      <button mat-raised-button type="submit" class="button" [disabled]="!orderForm.form.valid">
                        Submit Order
                      </button>
                    </div>
                  </div>
                </nb-card-footer> -->
              </nb-card>
              <div *ngIf="this.cart.contractTemplate && this.cart.contractTemplate.name != 'MSA'" >
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Other Remarks:</mat-label>
                  <textarea matInput name="otherRemarks" #otherRemarks="ngModel" id="otherRemarks" [(ngModel)]="this.cart.contractTemplate.otherRemarks"></textarea>
                </mat-form-field>
              </div>
              <div *ngIf="this.cart.contractTemplate && this.cart.contractTemplate.name == 'Export Offer'" >
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Payment Terms:</mat-label>
                  <textarea matInput name="paymentTerms" id="paymentTerms" [(ngModel)]="this.cart.paymentTerms"></textarea>
                </mat-form-field>
              </div>
              <div class="row" *ngIf="this.cart.contractTemplate" >
                <div class="col-lg-12 col-12" [ngClass]="this.cart.contractTemplate && this.cart.contractTemplate.name != 'MSA' ? 'alignRight' : 'alightLeft'">
                  <button [disabled]="!this.cart.customerId" mat-flat-button color="primary" type="button" (click)="previewContract()" class="button" style="margin: 10px">
                    Preview
                  </button>
                  <button [disabled]="!this.cart.customerId" mat-raised-button type="button" (click)="validateContract()" class="btn-save-change" style="margin: 10px">
                    Save
                  </button>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </nb-card-body>
    <!-- <nb-card-footer>
      <div class="row">
        <div class="col-lg-12 col-12" style="text-align: right;">
          <button [disabled]="!this.cart.customerId" mat-raised-button type="button" (click)="saveContract()" class="button">
            Create & Save
          </button>
        </div>
      </div>
    </nb-card-footer> -->
  </nb-card>
</form>

